module.exports = __webpack_public_path__ + "img/2_ru.c79cd4a9.jpg";